module.exports = __webpack_public_path__ + "img/Banner-01.1763a698.png";